var map = {
	"./calcs/2018/processed/data.json": 781,
	"./calcs/2019_01/processed/data.json": 782,
	"./calcs/2019_06/processed/data.json": 783,
	"./calcs/2019_08/processed/data.json": 784,
	"./calcs/2019_08_tax/processed/data.json": 785,
	"./calcs/2020_01/processed/data.json": 786
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 780;